// src/pages/Blog.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase";
import Seo from "../components/Seo";

const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === "function") return value.toDate();
  if (typeof value?.seconds === "number") return new Date(value.seconds * 1000);
  return null;
};

const formatDate = (value) => {
  const date = toDate(value);
  if (!date) return "";
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};

const toSummary = (text, maxLen = 160) => {
  const clean = (text || "").replace(/\s+/g, " ").trim();
  if (!clean) return "";
  if (clean.length <= maxLen) return clean;
  return `${clean.slice(0, maxLen).trim()}…`;
};

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const q = query(
      collection(db, "blogPosts"),
      where("published", "==", true),
      orderBy("createdAt", "desc")
    );
    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data()
        }));
        setPosts(list);
        setLoading(false);
      },
      (err) => {
        setError(err?.message || "Failed to load blog.");
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return (
    <main className="up-page container">
      <Seo
        title="Blog"
        description="Tips, guides, and news about playing free online games on OctoGames."
        path="/blog"
      />
      <div className="up-content-block">
        <h1 className="up-page-title">Blog</h1>
        <p className="up-page-subtitle">
          Tips, guides, and updates from the OctoGames team.
        </p>

        {loading && <p className="up-hint">Loading posts…</p>}
        {error && <p className="up-error">{error}</p>}

        {!loading && !error && (
          <div className="blog-list">
            {posts.length === 0 ? (
              <p className="up-hint">No posts yet. Check back soon.</p>
            ) : (
              <ul className="blog-list-ul">
                {posts.map((post) => (
                  <li key={post.id} className="blog-list-item">
                    <Link to={`/blog/${encodeURIComponent(post.slug || post.id)}`} className="blog-list-link">
                      <article className="blog-card">
                        {post.image && (
                          <div className="blog-card-image-wrap">
                            <img src={post.image} alt="" className="blog-card-image" />
                          </div>
                        )}
                        <div className="blog-card-body">
                          <time className="blog-card-date" dateTime={toDate(post.createdAt)?.toISOString()}>
                            {formatDate(post.createdAt)}
                          </time>
                          <h2 className="blog-card-title">{post.title || "Untitled"}</h2>
                          <p className="blog-card-summary">{toSummary(post.content)}</p>
                        </div>
                      </article>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </main>
  );
};

export default Blog;
